import { CoreApi } from '@inter-ikea-storageone/range';
import {
  CustomizedSlidingDoorComponentSerializer,
  CustomSlidingDoorSystem,
  RestrictValetHangersInSlidingDoorsValidation
} from '@inter-ikea-storageone/range-pax';
import { Feature } from '../../../features/Feature';

export class CustomizedSlidingDoor extends Feature {
  protected init(coreApi: CoreApi): void {
    coreApi.core.addValidation(new RestrictValetHangersInSlidingDoorsValidation(coreApi));
    const componentDeserializerRegistry = coreApi.getServices().componentDeserializerRegistry;
    componentDeserializerRegistry.register(new CustomizedSlidingDoorComponentSerializer());
    coreApi.registerSystem(new CustomSlidingDoorSystem(coreApi));
  }
}
